import { Box, Button } from "@mui/material";
import React from "react";

const AcceptRejectBtn = ({
  disable,
  onAccept,
  onReject,
  acceptTitle,
  rejectTitle,
}) => {
  return (
    <Box
      m={2}
      display="flex"
      gap={2}
      alignItems={"center"}
      justifyContent={"flex-end"}
    >
      <Button
        variant="text"
        color="success"
        disabled={disable}
        onClick={onAccept}
      >
        {acceptTitle}
      </Button>
      <Button
        variant="text"
        color="error"
        disabled={disable}
        onClick={onReject}
      >
        {rejectTitle}
      </Button>
    </Box>
  );
};

export default AcceptRejectBtn;
